import { PortfolioRepo } from "../../../portfolio/portfolio.repo";
import { isNullOrUndefined } from "util";
import { PortfolioCashTransactionDTO } from "../models/portfolioCashTransactionDto";

class CashTransactionDialogController {
  public cashTransaction: PortfolioCashTransactionDTO;

  public isReconciled: boolean;

  public originalCashTransaction: any;

  public transactionForm: ng.IFormController;

  public isDebitAmount: boolean = false;
  public isOverridden: boolean = false;
  public isLastTransaction: boolean = false;
  public operationDescriptionIsSell: boolean = false;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private portfolioRepo: PortfolioRepo,
    private notifyjs
  ) {}

  $onInit() {
    this.originalCashTransaction = this.cashTransaction;
    if (this.cashTransaction.amountDebited > 0) {
      this.isDebitAmount = true;
    }
    if (this.cashTransaction.lastTransaction.operationDescription === "Buy") {
      this.operationDescriptionIsSell = false;
    }
    if (this.cashTransaction.lastTransaction.operationDescription === "Sell") {
      this.operationDescriptionIsSell = true;
    }
  }

  save() {
    this.portfolioRepo
      .saveCashTransaction(this.cashTransaction, this.isReconciled)
      .then((res) => {
        this.$mdDialog.hide(true);
      })
      .catch((err) => {
        this.notifyjs(`Cash transaction CANNOT be updated : ${err.data}`);
      });
  }

  cancel() {
    this.cashTransaction = this.originalCashTransaction;
    this.$mdDialog.hide();
  }

  clearOutAmount() {
    this.cashTransaction.amountDebited = 0;
    this.cashTransaction.amountCredited = 0;
  }

  roundAmounts() {
    if (this.isDebitAmount) {
      if (!isNullOrUndefined(this.cashTransaction.amountDebited)) {
        this.transactionForm.amount.$viewValue =
          +this.transactionForm.amount.$viewValue;
        this.transactionForm.amount.$viewValue =
          this.transactionForm.amount.$viewValue.toFixed(2);
        this.cashTransaction.amountDebited =
          +this.cashTransaction.amountDebited.toFixed(2);
      }
    } else {
      if (!isNullOrUndefined(this.cashTransaction.amountCredited)) {
        this.transactionForm.amount.$viewValue =
          +this.transactionForm.amount.$viewValue;
        this.transactionForm.amount.$viewValue =
          this.transactionForm.amount.$viewValue.toFixed(2);
        this.cashTransaction.amountCredited =
          +this.cashTransaction.amountCredited.toFixed(2);
      }
    }
  }
  onIsLastTransactionChanged() {
    if (
      this.isLastTransaction !=
      this.cashTransaction.lastTransaction.isLastTransaction
    ) {
      this.cashTransaction.lastTransaction.isLastTransactionOverridden = true;
    }

    if (
      this.cashTransaction.lastTransaction.isLastTransaction &&
      (this.cashTransaction.lastTransaction.operationDescription === null ||
        this.cashTransaction.lastTransaction.operationDescription ===
          undefined ||
        this.cashTransaction.lastTransaction.operationDescription.trim() === ""
      || this.cashTransaction.lastTransaction.operationDescription.trim() === "_")
    ) {
      this.cashTransaction.lastTransaction.operationDescription = "Buy";
    }

    if(!this.cashTransaction.lastTransaction.isLastTransaction){
      this.cashTransaction.lastTransaction.operationDescription = "";
    }
  }

  onIsLastTransactionOperationTypeChanged() {
    this.cashTransaction.lastTransaction.operationDescription = this
      .operationDescriptionIsSell
      ? "Sell"
      : "Buy";
  }
}

export const cashTransactionDialog: angular.IComponentOptions = {
  template: require("./editCashTransaction.dialog.html"),
  controller: CashTransactionDialogController,
  bindings: {
    cashTransaction: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/performanceManagement/editCashTransactionDialog/editCashTransaction.dialog.ts